import axios from "axios";
import { draggableElement } from "./broker/poc";
import { validateUploadedFile } from "./contractors.js";

function fetchEmailCheckboxes(days) {
  if(days == "")
  {
      document.getElementById('empty_states').classList.remove('d-none');
      document.getElementById('states_txt').classList.add('d-none');
    document.getElementById('states_txt1').classList.add('d-none');


  }
  else{
    document.getElementById('empty_states').classList.add('d-none');
    document.getElementById('states_txt').classList.remove('d-none');
    document.getElementById('states_txt1').classList.remove('d-none');


  }
  
    let reminders = document.getElementById('notification-reminders')
    let textBoxValues = reminders.value
    let checkedBoxes = ['14', '30', '60', '90']
    let checkedElements = []
    var value=$('#multipleSelect').val();
    console.log(value.includes('every-14'));
   
   
    for (let i = 1; i < 30; i++) {
        let valueIndex = textBoxValues.indexOf(i + ' ')
        if (valueIndex >= 0) {
            if (valueIndex === 0) {
                textBoxValues = replaceTextBoxValues(textBoxValues, i)
            }
            if (valueIndex > 0 && textBoxValues[valueIndex - 1] === ' ') {
                textBoxValues = replaceTextBoxValues(textBoxValues, i)
            }
        }
        if (value.includes('every-14') == true && i < 14)
            if (checkedElements.indexOf(i.toString()) === -1)
                checkedElements.push(i.toString())

        if (value.includes('every-30') == true && i < 30)
            if (checkedElements.indexOf(i.toString()) === -1)
                checkedElements.push(i.toString())
    }
     
    checkedBoxes.forEach(function (element) {
        let checkboxStatus = value.includes(element);
        textBoxValues = textBoxValues.replace(element + ' ', '')
        if (checkboxStatus) {
            if (checkedElements.indexOf(element) === -1) {
                checkedElements.push(element)
            }
        }
    })
    let textToBeAppended = ''
    if (checkedElements.length > 0) {
        checkedElements.forEach(function (element) {
            textToBeAppended += element + ' '
        })
        reminders.value = textToBeAppended + textBoxValues
    } else {
        reminders.value = textBoxValues
    }
    console.log(checkedElements);
  
}

function displayTextBox(status) {
    if (status)
        document.getElementById('reminder-checks').classList.remove('d-none')
    else
        document.getElementById('reminder-checks').classList.add('d-none')
}

function replaceTextBoxValues(textBoxValues, value) {
    return textBoxValues.replace(value + ' ', '')
}

function emailEntityChanged(type,path) {
    if(path=="account/notifications"){
    window.location.href = "/account/notifications?entityType=" + type
    }
    else{
        window.location.href = "/properties/notifications?entityType=" + type

    }
}

function displayCheckedBoxes() {
    if (document.getElementById('notification_form')) {
        let checkedBoxes = ['14', '30', '60', '90', 'every-14', 'every-30', 'custom']

        checkedBoxes.forEach(checkedBox => {
            const checkboxElement = document.getElementById(checkedBox);
            const labelElement = document.getElementById("label-" + checkedBox);
        
            if (checkboxElement && checkboxElement.checked) {
                // If the label element exists, add the class
                if (labelElement) {
                    labelElement.classList.add('card-orientation-selected');
                }
            } else {
                // If the label element exists, remove the class
                if (labelElement) {
                    labelElement.classList.remove('card-orientation-selected');
                }
            }
        })
    }
}

function loadEmailAttachment(event) {
    let file = event.target.files[0]
    uploadEmailAttachment(file, event)
}

$(document).ready(function () {
    emailAttachmentDragDrop()
})

function emailAttachmentDragDrop() {
    let attachment = $('#email-attachment-upload')
    draggableElement(attachment)
    let email_attachment_div = document.getElementById('email-attachment')
    attachment.on('drop', function (e) {
        let files = e.originalEvent.dataTransfer.files;
        if (files.length > 1) {
            email_attachment_div.innerHTML = '<div class="text-danger">One file only</div>'
            return false
        }
        uploadEmailAttachment(files[0])
    });
}

function uploadEmailAttachment(file, event = null) {
    let email_attachment_div = document.getElementById('email-attachment')
    if (validateUploadedFile(file, file['name'], event)) {
        let formData = new FormData();
        formData.append("attachment", file);
        formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        axios.post('/account/email/attachment', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function (resp) {
            document.getElementById('attachment').value=resp.data.path
           var html=  '<div class="file-name-div d-flex" id="file-name-div">' 
           html += '<div class="text-width" style="width:120px !important" data-toggle="tooltip" data-placement="top" title="'+resp.data.name+'" target="_blank"> '
            html += '<a style="color:#6673E0 !important" id="attachment-email"  href="'+ resp.data.url +'" target="_blank">  <span class="text-width">' +resp.data.name+ ' </span> </a> </div>'
           html +='<a style="text-decoration: none !important;" href="'+ resp.data.url +'" target="_blank"><svg class="search-icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M10.7204 9.32909H10.0429L9.80274 9.1001C10.6432 8.13327 11.1492 6.87808 11.1492 5.51264C11.1492 2.46797 8.65352 0 5.57461 0C2.49571 0 0 2.46797 0 5.51264C0 8.55732 2.49571 11.0253 5.57461 11.0253C6.9554 11.0253 8.2247 10.5249 9.2024 9.69377L9.43396 9.93124V10.6012L13.7221 14.8333L15 13.5696L10.7204 9.32909ZM5.57461 9.32909C3.43911 9.32909 1.71527 7.62441 1.71527 5.51264C1.71527 3.40088 3.43911 1.6962 5.57461 1.6962C7.71012 1.6962 9.43396 3.40088 9.43396 5.51264C9.43396 7.62441 7.71012 9.32909 5.57461 9.32909Z" fill="#6673E0"/></svg> </a>'
            html +='<a onclick="delete_email()"><svg class="delete-icon"  width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M0.857143 13.6381C0.857143 14.5758 1.62857 15.3429 2.57143 15.3429H9.42857C10.3714 15.3429 11.1429 14.5758 11.1429 13.6381V3.40953H0.857143V13.6381ZM2.57143 5.1143H9.42857V13.6381H2.57143V5.1143ZM9 0.852383L8.14286 0H3.85714L3 0.852383H0V2.55715H12V0.852383H9Z" fill="#6673E0" /> </svg> </a>'
            html +='</div>'
            
            email_attachment_div.innerHTML = html; 
        })
    }
    else{
        email_attachment_div.innerHTML = '<div class="text-danger">Invalid file</div>'
    }
}
function delete_email(){
    let cert= document.getElementById('email-attachment');
    cert.innerHTML="";
    document.getElementById('attachment').value=null;
}
// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const emailNotificationsScriptModule = {
    fetchEmailCheckboxes,
    displayTextBox,
    replaceTextBoxValues,
    emailEntityChanged,
    displayCheckedBoxes,
    loadEmailAttachment,
    emailAttachmentDragDrop,
    uploadEmailAttachment,
    delete_email,
};